import * as React from "react";
import { forwardRef } from "react";
const SvgCloseAlt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 3.61133, width: 19.8291, height: 2, transform: "rotate(45 3.61133 0)" }), /* @__PURE__ */ React.createElement("rect", { x: 2.19727, y: 14.0213, width: 19.8291, height: 2, transform: "rotate(-45 2.19727 14.0213)" }));
const ForwardRef = forwardRef(SvgCloseAlt);
export { ForwardRef as ReactComponent };
